import { EditFilled, FilterOutlined, PlusCircleFilled } from '@ant-design/icons';
import { Card, Col, DatePicker, Row, Table, Tag } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../../Components/auth/AuthService';
import { showMessage } from '../../Components/Utils/message';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { encodeId } from '../../Components/common/CommonFun';
import { styled } from '@mui/system';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService();

const RostersList = () => {
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  var layoutDispatch = useLoadingDispatch();
  const [rosters, setRosters] = useState([]);
  const [filters, setFilters] = useState({
    dateRange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });

  const handleRowClick = (id) => {
    const hasedID = encodeId(id)

    navigate(`/rosters/${hasedID}`)
  };

  const rosterColumns = [

    {
      title: 'Date',
      render: (record) => (
        <span>{record?.roster_date ? dayjs(record?.roster_date).format('DD-MM-YYYY') : ''}</span>
      ),
      width: 135,
    },
    {
      title: 'Helper',
      render(record) {
        return (
          <div>
            {
              record?.helpers.map((helper, index) => (
                <Tag color="blue" key={index}>
                  {helper.helper}
                </Tag>
              ))
            }
          </div>
        )
      }
    },


    {
      title: 'Action',
      key: 'action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <EditFilled onClick={() => handleRowClick(record.id)} style={{ fontSize: '25px', cursor: "pointer", color: "#006cb8" }} />
          </div>
        );
      },
    },
  ];

  const getRosters = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {};
    if (filters?.dateRange && filters?.dateRange[0] && filters?.dateRange[1]) {
      dataToSend.start_date = dayjs(filters?.dateRange[0]).format("YYYY-MM-DD");
      dataToSend.end_date = dayjs(filters?.dateRange[1]).format("YYYY-MM-DD");
    }
    try {
      const res = await Auth.post(`/warehouse-roster/warehouse-rosters`, dataToSend);
      if (res?.ack) {
        console.log(res?.rosters);
        const rosterData = res?.rosters
        const combined = rosterData.reduce((acc, item) => {
          const helperObj = { helper: item.object_title, helper_id: item.object_id };
          const existing = acc.find(entry => entry.id === item.id);

          if (existing) {
            existing.helpers.push(helperObj);
          } else {
            acc.push({
              id: item.id,
              roster_date: item.roster_date,
              record_type: item.record_type,
              helpers: [helperObj],
            });
          }

          return acc;
        }, []);
        console.log('combined', combined);

        setRosters(combined);
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')

    }
    finally {
      hideLoading(layoutDispatch);
    }
  }

  useEffect(() => {
    getRosters();
  }, [filters?.dateRange]);

  return (
    <DataSheet>
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff' }} /> Rosters</>}
        style={{ marginBottom: '10px' }}
        extra={
          <>
            <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF", }} onClick={() => navigate("/rosters/new")} />
          </>
        }
      >
        <Row gutter={[6, 1]}>
          <Col xs={24} md={12} lg={8}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
            <RangePicker
              style={{ width: '100%' }}
              value={filters.dateRange}
              onChange={(dates) => setFilters(prev => ({ ...prev, dateRange: dates }))}
              format="DD-MM-YYYY"
              allowClear={false}
            />
          </Col>
        </Row>
      </Card>
        <Table
          dataSource={rosters}
          style={{ overflowX: "auto" }}
          columns={rosterColumns}
          pagination={false}
          bordered
          footer={() => `List of Rosters - Total Records: ${rosters.length === 0 ? "0" : rosters.length}`}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          scroll={{ x: 'max-content' }}
        />
    </DataSheet>
  )
}

export default RostersList
